import { useProductDetailsHook } from '../hooks/use-product-details.hook'
import { ProductDetailsOrderInterface } from '../interfaces/product-details-order.interface'

export function ProductDetailsOrderContainer() {
  const productDetailsHook = useProductDetailsHook()

  return <ProductDetailsOrderInterface {...productDetailsHook} />
}
